export default __webpack_public_path__ + "static/media/effect-256.b0270d50.mp3";